// extracted by css-extract-rspack-plugin
module.exports =  {"hedy":"Hedy-DkQm__hedy"};